import BlogLinkCard from "./BlogLinkCard";
import MainaIcon from "./MainaIcon";
import Alert from "./Alert";

function Section01({ config }) {
  return (
    <div
      id="tabs-with-card-1"
      className="hidden"
      role="tabpanel"
      aria-labelledby="tabs-with-card-item-1"
    >
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="space-y-8 mb-12">
                <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                  <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight">
                    <div className="mr-4">
                      <MainaIcon sizeNum="3.5" />
                    </div>
                    マイナポータルで確認
                  </h2>
                </div>
              </div>
            )}

            <p>マイナ保険証が利用できる方は、マイナポータルでご自分の記号・番号・枝番やご加入の組合の保険者番号を確認できます。</p>

            <Alert title="事前にマイナンバーカードの保険証利用の申請が必要です。">
              ご自分のマイナンバーカードが申請済みかどうかはマイナポータルで確認できます。申請自体もマイナポータルから行うことができます。
              <br />
              以下の手順に従ってマイナポータルにログインしてご確認ください。
            </Alert>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-gray-200">
                手順１：マイナポータルにログイン
              </h3>

              <p className="text-lg text-gray-800">
                <a href="https://myna.go.jp/" target="myna">
                  マイナポータル
                </a>
                へのログイン方法はデジタル庁のホームページでくわしい動画解説が公開されていますのでご参照ください。
              </p>
              <BlogLinkCard
                title="マイナポータルへのログイン方法"
                description="利用ガイド｜マイナポータルアプリ｜デジタル庁"
                imageUrl="https://services.digital.go.jp/uploads/og_images/ogp.png"
                link="https://services.digital.go.jp/mynaportal-app/help/"
                target="digital_go_jp"
              />
            </div>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-gray-200">
                手順２：メニューから「健康保険証」を選択
              </h3>

              <p className="text-lg text-gray-800">
                ログイン後、ホーム画面の「証明書」＞「健康保険証」を選択します。
              </p>
              <figure className="flex flex-col justify-center items-center">
                <img
                  className="rounded-xl shadow-md"
                  src={`${process.env.PUBLIC_URL}/images/mynaportal-home01.png`}
                  alt="ホーム画面の「証明書」＞「健康保険証」を選択します。"
                  loading="lazy"
                />
                <figcaption className="mt-3 text-sm text-center text-gray-500">
                  iPhoneの場合の画面です。ご利用のデバイスによって一部異なる場合があります。
                </figcaption>
              </figure>
            </div>

            <div className="space-y-8 scroll-mt-24 bg-white border rounded-lg p-8 mt-10">
              <h3 className="text-2xl font-semibold pb-6 border-b border-gray-200">
                手順３：健康保険証の資格情報を確認
              </h3>

              <p className="text-lg text-gray-800">
                健康保険証の資格情報が表示されるので画面をスクロールして必要な情報を確認してください。
              </p>
              <figure className="flex flex-col justify-center items-center">
                <img
                  className="rounded-xl shadow-md"
                  src={`${process.env.PUBLIC_URL}/images/mynaportal-hokensho01.png`}
                  alt="保険証の記号番号、保険者番号を確認できます"
                  loading="lazy"
                />
                <figcaption className="mt-3 text-sm text-center text-gray-500">
                  iPhoneの場合の画面です。ご利用のデバイスによって一部異なる場合があります。
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section01;
